<div class="error" *ngIf="showError" [class.rounded]="rounded">
  <span>{{getError()}}</span>
</div>
